import { Component, ChangeDetectionStrategy} from '@angular/core';

/**
 * Rótulo simples que projeta seu conteúdo dentro de um elemento `<label>`.
 *
 * Não define estilos próprios — herda tipografia/cor do contexto e do design
 * system. Usa encapsulamento padrão (`Emulated`).
 *
 * @example
 * ```html
 * <ai-label>Nome completo</ai-label>
 * ```
 */
@Component({
    selector: 'ai-label',
    templateUrl: './label.component.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Label {}
